import { useLayoutEffect, useRef, useState } from 'react'
import { createPortal } from 'react-dom'

function createWrapperAndAppendToBody(wrapperId: string): HTMLElement {
  const wrapperElement = document.createElement('div')
  wrapperElement.setAttribute('id', wrapperId)
  document.body.appendChild(wrapperElement)
  return wrapperElement
}

interface Props {
  children: React.ReactNode
  wrapperId?: string
}

function Portal({ children, wrapperId = 'react-portal-wrapper' }: Props) {
  const [wrapperElement, setWrapperElement] = useState<HTMLElement | null>(null)
  const systemCreated = useRef(false)

  useLayoutEffect(() => {
    let element = document.getElementById(wrapperId)

    if (!element) {
      systemCreated.current = true
      element = createWrapperAndAppendToBody(wrapperId)
    }

    setWrapperElement(element)

    return () => {
      // delete created child element on Component Leave
      if (systemCreated.current && element && element.parentNode) {
        element.parentNode.removeChild(element)
      }
    }
  }, [wrapperId])

  // wrapperElement state will be null on the very first render.
  if (wrapperElement === null) return null

  return createPortal(children, wrapperElement)
}

export { Portal }
